export default __webpack_public_path__ + "static/media/iam_s1.d7c8336c.png";